// Bulk request type categories: what happens when a request of that type is approved.
export const BULK_CATEGORY_TABS = [
  { value: 'action', label: 'Action' },
  { value: 'display', label: 'Display' },
  { value: 'request', label: 'Request' },
];

export const BULK_CATEGORY_HINTS = {
  action: 'Approving changes the status of every candidate in the request.',
  display: 'Approving records the decision; the request and its outcome are shown in the candidate workflow step popup.',
  request: 'Approving only records the decision — nothing else happens.',
};
